export enum FeedbackCategory {
    Suggestion = 1,
    Compliment = 2,
    ReportABug = 3,
    Request = 4,
}
